<breadcrumb-navigation [titles]="[{ key: 'PRIVACY_TITLE', url: ''}]"></breadcrumb-navigation>

<div class="data-privacy mx:p-4 sm:px-0 sm:pl-4">
    <div class="data-privacy__title">{{ "PRIVACY_TITLE" | translate }}</div>
    <div class="data-privacy__content">
        <nz-table
          class="e-shop-table"
          style="width: 100%;"
          [nzData]="tableData"
          #fixedTable
          [nzFrontPagination]="false"
          [nzScroll]="{ x: 'auto' }"
          >
          <thead>
            <tr>
              <th *ngFor="let col of columns" [nzWidth]="col.width || '150px'">
                {{ col.name }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of privacyData; trackBy: trackByPrivacyId">
              <td>
                <span class="link-text" (click)="handleViewPrivacy(data.url)">{{ data.subject }}</span>
              </td>
              <td>
                {{ data.purpose }}
                <span class="link-text" (click)="handleViewPrivacy(data.url)">{{data.subject}}</span>
              </td>
              <td>
                <span class="status-tag">{{data.status === 1? ("PRIVACY_AGREE" | translate): ("PRIVACY_NOT_AGREE" | translate)}}</span>
              </td>
              <td>{{ data.updateTime }}</td>
              <td>
                <span *ngIf="data.status === 1" class="link-text" (click)="revokePrivacy(data)">{{ "PRIVACY_REVOKE" | translate }}</span>
              </td>
            </tr>
          </tbody>
        </nz-table>
    </div>
</div>






